export default "__VITE_ASSET__ZNvZegPw__"